/**
 *
 * @param autoCompleteTerms
 * @returns {JSX.Element|string}
 * @constructor
 */
const AutoCompleteSuggestions = ({autoCompleteTerms, dataListId}) => {

    return autoCompleteTerms  && autoCompleteTerms?.length > 0 ? (
        <datalist id={dataListId ?? 'suggestions'}>
            {
                autoCompleteTerms.map(({ word }, i) => (
                    <option key={i} value={word} />
                ))
            }
        </datalist>
    ) : ''
}

export default AutoCompleteSuggestions;
